import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CertificateCard = () => {

    const card = [
        { img: `/images/2. Rajgarh to Bawal_page-0001.jpg`, name: 'Rajgarh to Bawal' },
        { img: `/images/3. Gohana-Lakhan Majra_page-0001.jpg`, name: 'Gohana-Lakhan' },
        { img: `/images/4. Various Road_page-0001.jpg`, name: 'Various Road' },
        { img: `/images/8. Ambala-Zirakpur_page-0001.jpg`, name: 'Ambala-Zirakpur' },
        { img: `/images/9. Umang Bhardwaj Chowk_page-0001.jpg`, name: 'Umang Bhardwaj Chowk' },
        { img: `/images/10. Dadri-Mahendergarh Road.jpg`, name: 'Dadri-Mahendergarh' },
        { img: `/images/14. Sangrur Bypass.jpg`, name: 'Sangrur Bypass' },
        { img: `/images/15. Ferojpur Jhirka Biwan.jpg`, name: 'Ferojpur Jhirka Biwan' },
        { img: `/images/16. Pataudi Road to Sec. 37-C Gurgaon.jpg`, name: 'Pataudi road to sec.37-C Gurgaon' },
    ];

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 4,  // Default slides to show for large screens
        autoplay: true,   // Enable auto-scrolling
        autoplaySpeed: 2000, // Auto-scroll every 2 seconds
        responsive: [
            {
                breakpoint: 1024, // For medium-sized screens
                settings: {
                    slidesToShow: 3, // Show 3 slides
                    autoplay: true, // Enable auto-scrolling
                    autoplaySpeed: 2000,
                    infinite: true,
                    speed: 500,
                }
            },
            {
                breakpoint: 768, // For small screens
                settings: {
                    slidesToShow: 2, // Show 2 slides
                    autoplay: true, // Enable auto-scrolling
                    autoplaySpeed: 2000,
                    infinite: true,
                    speed: 500,
                }
            },
            {
                breakpoint: 480, // For extra small screens
                settings: {
                    slidesToShow: 1, // Show 1 slide
                    autoplay: true, // Enable auto-scrolling
                    autoplaySpeed: 2000,
                    infinite: true,
                    speed: 500,
                }
            }
        ]
    };
    

    return (
        <div className='w-[96vw]  mx-auto max-w-[98vw] justify-center'>
            <div className='mt-40 highlightblue'>
                <Slider {...settings}>
                    {card.map((d, index) => (
                        <div key={index} className='cards px-4 w-[80vw] md:h[] rounded-xl'>
                            <div className='flex mt-4 justify-center'>
                                <img className='h-[380px] w-[300px] rounded-xl card-div' src={d.img} alt={d.name} />
                            </div>
                            <div>
                                <p className='text-center pt-4 text-white'>{d.name}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default CertificateCard;
